<template>
  <main class="contact-page">
    <div class="contact-card">
      <h1 class="contact-title">Contáctanos</h1>
        <p class="subtitle">
          ¿Tienes dudas o quieres trabajar con nosotros? Escríbenos a través de nuestro <strong>formulario de contacto</strong> y recibe soporte personalizado.
        </p>


      <form class="contact-form" @submit.prevent="sendMessage">
        <!-- NAME -->
        <div class="input-group">
          <label for="name">Nombre</label>
          <input type="text" id="name" v-model="name" placeholder="Tu nombre" required>
        </div>

        <!-- EMAIL -->
        <div class="input-group">
          <label for="email">Correo</label>
          <input type="email" id="email" v-model="email" placeholder="tu@email.com" required>
        </div>

        <!-- MESSAGE -->
        <div class="input-group">
          <label for="message">Mensaje</label>
          <textarea id="message" v-model="message" placeholder="Escribe tu mensaje..." required></textarea>
        </div>

        <!-- RECAPTCHA -->
        <div class="captcha-wrapper">
          <VueRecaptcha
            sitekey="6LdZzPQsAAAAAMjIu-bSvZuOxIFXu6Gu1zcCxhQm"
            @verify="onCaptchaVerified"
            @expired="onCaptchaExpired"
          />
        </div>

        <!-- BUTTON -->
        <button class="btn-enviar" type="submit" :disabled="loading">
          <span v-if="loading" class="spinner"></span>
          {{ loading ? "Enviando..." : "Enviar mensaje →" }}
        </button>
      </form>

      <p v-if="successMessage" class="success-message">{{ successMessage }}</p>
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
    </div>
  </main>
</template>

<script>
import axios from "axios";
import VueRecaptcha from "vue3-recaptcha2";

export default {
  name: "ContactComponent",
  components: { VueRecaptcha },

  data() {
    return {
      name: "",
      email: "",
      message: "",
      recaptchaToken: "",
      loading: false,
      successMessage: "",
      errorMessage: ""
    };
  },

  methods: {
    onCaptchaVerified(token) {
      this.recaptchaToken = token;
    },

    onCaptchaExpired() {
      this.recaptchaToken = "";
    },

    async sendMessage() {

      if (!this.recaptchaToken) {
        this.errorMessage = "Completa el reCAPTCHA.";
        return;
      }

      this.loading = true;
      this.successMessage = "";
      this.errorMessage = "";

      try {
        await axios.post("http://localhost:5000/api/contact", {
          name: this.name,
          email: this.email,
          message: this.message,
          recaptchaToken: this.recaptchaToken
        });

        this.successMessage = "Mensaje enviado correctamente.";
        this.name = "";
        this.email = "";
        this.message = "";
        this.recaptchaToken = "";

      } catch (error) {
        console.error("❌ Error en envío:", error);
        this.errorMessage = "Error al enviar el mensaje.";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>


<style scoped>

/* PAGE */
.contact-page{
  display:flex;
  justify-content:center;
  align-items:center;
  min-height:100vh;
  padding:3rem 1rem;
  background:linear-gradient(135deg,#f5f7fa,#8da39a);
}

/* CARD */
.contact-card{
  width:100%;
  max-width:560px;
  background:rgba(255,255,255,0.95);
  backdrop-filter:blur(10px);
  padding:2.5rem;
  border-radius:22px;
  box-shadow:0 15px 40px rgba(0,0,0,0.12);
  display:flex;
  flex-direction:column;
  gap:1.2rem;
  animation:fadeIn .5s ease;
}

/* TITLE */
.contact-title{
  text-align:center;
  font-size:2.2rem;
  font-weight:700;
  color:#1b1b1b;
  margin-bottom:.3rem;
}

/* SUBTITLE */
.subtitle{
  text-align:center;
  color:#666;
  font-size:.95rem;
  margin-bottom:1rem;
}

/* FORM */
.contact-form{
  display:flex;
  flex-direction:column;
  gap:1.3rem;
}

/* INPUT GROUP */
.input-group{
  display:flex;
  flex-direction:column;
  gap:.45rem;
}

/* LABEL */
label{
  font-size:.9rem;
  color:#444;
  font-weight:500;
}

/* INPUTS */
input,
textarea{
  border:1px solid #ddd;
  border-radius:12px;
  padding:.9rem 1rem;
  font-size:.96rem;
  transition:all .25s ease;
  background:white;
}

/* FOCUS */
input:focus,
textarea:focus{
  outline:none;
  border-color:#198754;
  box-shadow:0 0 0 4px rgba(25,135,84,0.15);
  transform:translateY(-1px);
}

/* TEXTAREA */
textarea{
  min-height:130px;
  resize:vertical;
}

/* CAPTCHA */
.captcha-wrapper{
  display:flex;
  justify-content:center;
}

/* BUTTON */
.btn-enviar{
  margin-top:.5rem;
  display:flex;
  justify-content:center;
  align-items:center;
  gap:.6rem;
  background:linear-gradient(135deg,#1f4037,#14532d);
  color:white;
  border:none;
  border-radius:12px;
  padding:.95rem;
  font-size:1rem;
  font-weight:600;
  cursor:pointer;
  transition:all .25s ease;
}

.btn-enviar:hover{
  transform:translateY(-2px);
  box-shadow:0 10px 25px rgba(20,108,76,0.3);
}

.btn-enviar:disabled{
  opacity:.8;
  cursor:not-allowed;
}

/* SPINNER */
.spinner{
  width:18px;
  height:18px;
  border:3px solid rgba(255,255,255,0.3);
  border-top:3px solid white;
  border-radius:50%;
  animation:spin .8s linear infinite;
}

/* SUCCESS */
.success-message{
  text-align:center;
  color:#198754;
  font-weight:600;
}

/* ERROR */
.error-message{
  text-align:center;
  color:#dc3545;
  font-weight:600;
}

/* ANIMATIONS */
@keyframes spin{
  0%{transform:rotate(0)}
  100%{transform:rotate(360deg)}
}

@keyframes fadeIn{
  from{
    opacity:0;
    transform:translateY(20px);
  }
  to{
    opacity:1;
    transform:translateY(0);
  }
}

/* MOBILE */
@media (max-width:600px){
  .contact-card{
    padding:2rem 1.4rem;
  }

  .contact-title{
    font-size:1.8rem;
  }
}

</style>